import { render } from "./BusinessStaff.vue?vue&type=template&id=5b19390d&scoped=true"
import script from "./BusinessStaff.vue?vue&type=script&lang=js"
export * from "./BusinessStaff.vue?vue&type=script&lang=js"

import "./BusinessStaff.vue?vue&type=style&index=0&id=5b19390d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b19390d"]])

export default __exports__